import React from "react";
import { CircularProgress, Box } from "@mui/material";

const NewLoadingCircle = ({
  isLoading = false,
  isError = false,
  errorMessage = "Something went wrong."
}) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress size="4rem" />
        <Box p={2}>Loading...</Box>
      </Box>
    );
  }

  if (isError) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <p>{errorMessage}</p>
      </Box>
    );
  }

  return null;
};

export default NewLoadingCircle;
